import * as types from '@/store/mutation-types'

const mutations = {
  [types.SET_TOKEN](state, token) {
    state.token = token
  },
  [types.SET_OPEN_ID](state, openId) {
    state.openId = openId
  },
  [types.SET_BIND](state, bind) {
    state.bind = bind
  },
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_LOGOUT](state) {
    state.token = ''
    state.bind = 'N'
    state.userInfo = {}
  },
}
export default mutations
